var map = {
	"./bg-2.png": 220,
	"./bg.png": 851,
	"./close.png": 221,
	"./delete.png": 142,
	"./download.png": 143,
	"./filter.png": 222,
	"./hot-major.png": 223,
	"./input_subject.png": 224,
	"./major.png": 225,
	"./plus.png": 144,
	"./protect.png": 852,
	"./recover.png": 145,
	"./rush.png": 853,
	"./skill.png": 226,
	"./stable.png": 854,
	"./subject.png": 227,
	"./total.png": 228,
	"./zhuan.png": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;



//////////////////
// WEBPACK FOOTER
// ./src/images/tocollege ^\.\/.*\.png$
// module id = 249
// module chunks = 0